import React from 'react'
import ReactStars from 'react-rating-stars-component';
import { Link, useLocation } from 'react-router-dom';
import wishlist from "../images/wish.svg";
import watch from "../images/watch.jpg";
import speaker from "../images/speaker.jpg"
import tab from "../images/tab3.jpg"
import prodcompare from "../images/prodcompare.svg"
import view from "../images/view.svg"
import addcart from "../images/add-cart.svg"


const ProductCard = (props) => {
    const { grid, data } = props;
    console.log(data)
    let location = useLocation();

  return (
    <>
        {
            data && data?.map((item, index) => {
                return (
                    <div 
                        key={index}
                        className={` ${location.pathname === "/store" ? `gr-${grid}` : "col-3"} mb-3`}>
        <Link to='/product/:id' className='product-card position-relative'>
            <div className='wishlist-icon position-absolute'>
                <button className='border-0 bg-transparent'>
                    <img src={wishlist} alt='wishlist' />
                </button>
            </div>
            <div className='product-image'>
  {item?.images && item.images.length > 0 && item.images[0]?.url ? (
    <img src={item.images[0].url} className='img-fluid mx-auto' alt='watch' width={260} />
  ) : (
    <img src={tab} className='img-fluid mx-auto' alt='speaker' width={260} />
  )}
    <img src={tab} className='img-fluid mx-auto' alt='speaker' width={260} />
</div>

            <div className='product-details'>
                <h6 className='brand'>{ item?.brand }</h6>
                <h5 className='product-title'>
                    { item?.title }
                </h5>
                <ReactStars count={5} size={24} value={item?.totalrating.toString()} edit={false} activeColor='#ffd700' />
                <p className={`description ${grid === 12 ? "d-block" : "d-none"}`}
                    dangerouslySetInnerHTML={{ __html: item?.description }}
                >
                </p>
                <p className='price'>$ {item?.price}</p>
            </div>
            <div className='action-bar position-absolute'>
                <div className='d-flex flex-column gap-15'>
                    <button className='border-0 bg-transparent'>
                        <img src={prodcompare} alt='compare' />
                    </button>
                    <button className='border-0 bg-transparent'>
                        <img src={view} alt='view' />
                    </button>
                    <button className='border-0 bg-transparent'>
                        <img src={addcart} alt='addcart' />
                    </button>
                </div>
            </div>
        </Link>
        </div>
                )
            })
        }
        
        
    </>
  )
}

export default ProductCard